export const H2_STUDY_SUBJECTS = {
  "h2-maths-notes": {
    label: "H2 Maths",
    quizSubject: "h2-maths",
    firstTopicHref:
      "/blog/h2-maths-notes/H2-Maths-Notes-1-Functions-and-Graphs",
  },
  "h2-physics-notes": {
    label: "H2 Physics",
    quizSubject: "h2-physics",
    firstTopicHref: "/blog/h2-physics-notes/1-Quantities-and-Measurements",
  },
  "h2-chemistry-notes": {
    label: "H2 Chemistry",
    quizSubject: "h2-chemistry",
    firstTopicHref:
      "/blog/h2-chemistry-notes/H2-Chemistry-Topic-1-Atomic-Structure",
  },
  "h2-biology-notes": {
    label: "H2 Biology",
    quizSubject: "h2-biology",
    firstTopicHref:
      "/blog/h2-biology-notes/H2-Biology-Core-1-Cell-and-Biomolecules",
  },
} as const;

export type H2StudySubject = keyof typeof H2_STUDY_SUBJECTS;

export function isH2StudySubject(value: string): value is H2StudySubject {
  return value in H2_STUDY_SUBJECTS;
}

export function getH2SubjectRoutes(subject: H2StudySubject) {
  const config = H2_STUDY_SUBJECTS[subject];
  return {
    ...config,
    notesHubHref: `/blog/${subject}`,
    quizHubHref: `/quizzes/${config.quizSubject}`,
    videoHubHref: `/videos#${config.quizSubject}`,
  } as const;
}

export function inferH2TopicOrder(
  subject: H2StudySubject,
  slug: string
): readonly number[] | null {
  if (subject === "h2-physics-notes") {
    const match = slug.match(/^(\d+)-/);
    return match ? [Number(match[1])] : null;
  }

  if (subject === "h2-chemistry-notes") {
    const match = slug.match(/H2-Chemistry-Topic-(\d+)-/i);
    return match ? [Number(match[1])] : null;
  }

  if (subject === "h2-biology-notes") {
    const core = slug.match(/H2-Biology-Core-(\d+)-/i);
    if (core) return [0, Number(core[1])];
    const extension = slug.match(/H2-Biology-Extension-([A-Z])-/i);
    if (extension) {
      return [1, extension[1].toUpperCase().charCodeAt(0)];
    }
    return null;
  }

  const overview = slug.match(/H2-Maths-Notes-00([AB])-/i);
  if (overview) {
    return [0, overview[1].toUpperCase() === "A" ? 1 : 2];
  }

  const match = slug.match(/H2-Maths-Notes-(\d+)(?:-(\d+))?/i);
  if (!match) return null;
  return match[2] ? [Number(match[1]), Number(match[2])] : [Number(match[1])];
}

export function topicOrdersMatch(
  noteOrder: readonly number[] | null,
  resourceOrder: readonly number[]
): boolean {
  if (!noteOrder || noteOrder.length === 0) return false;
  return noteOrder.every((value, index) => resourceOrder[index] === value);
}

export function topicLabelFromSlug(slug: string): string {
  return slug
    .replace(
      /^H2-(?:Maths-Notes|Chemistry-Topic|Biology)-(?:Core-|Extension-)?/i,
      ""
    )
    .replace(/^\d+(?:-\d+)?-/, "")
    .replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
